<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBandwidth_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M22.862 12.748c-.758-4.828-4.786-8.661-9.646-9.182C6.596 2.855 1 8.024 1 14.5c0 1.709.396 3.324 1.094 4.766.223.46.71.734 1.221.734h17.371c.511 0 .997-.274 1.22-.734a10.954 10.954 0 0 0 .956-6.518Zm-4.408-1.04-5.46 5.379a2.07 2.07 0 0 1-1.81.567 2.065 2.065 0 0 1-1.35-.857 2.066 2.066 0 0 1-.305-1.723c.15-.566.538-1.07 1.119-1.345l6.927-3.281c.792-.374 1.504.644.879 1.26Z"
    />
</svg>
